import { render, staticRenderFns } from "./JobCommunication.vue?vue&type=template&id=32768766&"
import script from "./JobCommunication.vue?vue&type=script&lang=js&"
export * from "./JobCommunication.vue?vue&type=script&lang=js&"
import style0 from "./JobCommunication.vue?vue&type=style&index=0&id=32768766&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports